/**
 * @generated SignedSource<<e45172a4dc74e2148f9b1826b70ee1a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SendNotesModalQuery$variables = {
  noteId: string;
};
export type SendNotesModalQuery$data = {
  readonly note: {
    readonly meetingRecordings?: ReadonlyArray<{
      readonly id: string;
    }> | null;
    readonly sendNoteToCrmAutomationIsValid?: boolean;
    readonly sendNoteToHubspotAutomationIsActive?: boolean;
    readonly sendNoteToSalesforceAutomationIsActive?: boolean;
  } | null;
  readonly viewer: {
    readonly integrations: {
      readonly confluence: {
        readonly isConnected: boolean;
        readonly requiresReconnect: boolean;
      } | null;
      readonly google: {
        readonly isActive: boolean;
      } | null;
      readonly notion: {
        readonly isConnected: boolean;
      } | null;
      readonly office365: {
        readonly scopes: ReadonlyArray<string>;
      } | null;
      readonly slack: ReadonlyArray<{
        readonly scopes: string;
      } | null> | null;
      readonly zapier: {
        readonly hasNotePushHook: boolean | null;
        readonly isConnected: boolean;
      } | null;
    };
  };
};
export type SendNotesModalQuery = {
  response: SendNotesModalQuery$data;
  variables: SendNotesModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scopes",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNotePushHook",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiresReconnect",
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToCrmAutomationIsValid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToHubspotAutomationIsActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendNoteToSalesforceAutomationIsActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecording",
      "kind": "LinkedField",
      "name": "meetingRecordings",
      "plural": true,
      "selections": [
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
},
v10 = [
  (v1/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendNotesModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserNode",
                "kind": "LinkedField",
                "name": "slack",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZapierUserNode",
                "kind": "LinkedField",
                "name": "zapier",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleUserNode",
                "kind": "LinkedField",
                "name": "google",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotionUserNode",
                "kind": "LinkedField",
                "name": "notion",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConfluenceUserNode",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendNotesModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SlackUserNode",
                "kind": "LinkedField",
                "name": "slack",
                "plural": true,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ZapierUserNode",
                "kind": "LinkedField",
                "name": "zapier",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GoogleUserNode",
                "kind": "LinkedField",
                "name": "google",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NotionUserNode",
                "kind": "LinkedField",
                "name": "notion",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ConfluenceUserNode",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "note",
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v9/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19ea3e46becfc0c6d967197b65c87a41",
    "id": null,
    "metadata": {},
    "name": "SendNotesModalQuery",
    "operationKind": "query",
    "text": "query SendNotesModalQuery(\n  $noteId: ID!\n) {\n  viewer {\n    integrations {\n      slack {\n        scopes\n        id\n      }\n      office365 {\n        scopes\n        id\n      }\n      zapier {\n        isConnected\n        hasNotePushHook\n        id\n      }\n      google {\n        isActive\n        id\n      }\n      notion {\n        isConnected\n        id\n      }\n      confluence {\n        isConnected\n        requiresReconnect\n        id\n      }\n    }\n    id\n  }\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      sendNoteToCrmAutomationIsValid\n      sendNoteToHubspotAutomationIsActive\n      sendNoteToSalesforceAutomationIsActive\n      meetingRecordings {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "afaaec5a56556a0c2b383ead6643c30c";

export default node;
